<template>
  <div class="sure-order-container">
    <!-- 回退 -->
    <div class="goBackIcon" @click="handleGoBack">
      <el-icon class="el-icon-back"></el-icon>
    </div>
    <!-- 主体 -->
    <div class="sure-order">
      <!-- 标题 -->
      <div class="sure-order-title">确认订单</div>
      <!-- 地址 -->
      <AddressList :choose-add-id="chooseAddId" @changAddId="changeAddId" ref="addressListRef" />
      <!-- 订单表单 -->
      <div class="sure-order-submit">
        <!-- 订单表单-顶部 -->
        <div class="submit-header" :style="{ background: getBgColor(goodDetail.storeType) }">
          <div class="header-title">确认商品信息</div>
          <div class="header-money">
            <div class="money-pick">
              <span>可用提货值</span>
              <span>{{ allDeliveyVal || 0 }}提货值</span>
            </div>
            <div class="money-amount">
              <span>可用金额</span>
              <span>￥{{ allBanlce || 0 }}</span>
            </div>
          </div>
        </div>
        <!-- 订单表单-信息 -->
        <div class="submit-body">
          <div class="good-des">
            <div class="des-info des-common">
              <div class="info-title title-common">商品描述</div>
              <div class="info-body">
                <div class="store-info">
                  <img v-if="goodDetail.storeType == 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img v-if="goodDetail.storeType == 'S'" src="@/assets/images/pt-zy.png" alt="">
                  <span>{{ goodDetail.storeName }}</span>
                </div>
                <div class="good-info">
                  <img :src="currentPrice.img" alt="">
                  <div class="info-text">
                    <div class="text-des">{{ goodDetail.commodityName }}</div>
                    <div class="text-sku">{{ currentPrice.skuName.replace(/\|/g, " ") }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="des-num des-common">
              <div class="price-title title-common">单价</div>
              <div class="price-body">
                <span v-if="goodDetail.pays[0].payType === 1" style="font-size: 14px;margin-right: -4px;">¥</span>
                {{ currentPrice.discountPrice }}
                <span v-if="goodDetail.pays[0].payType !== 1">提货值</span>
              </div>
            </div>
            <div class="des-freight des-common" v-if="shippingFee > 0">
              <div class="freight-title title-common">运费</div>
              <div class="freight-body"><span>￥</span>{{ shippingFee }}</div>
            </div>
            <div class="des-price des-common">
              <div class="num-title title-common">数量</div>
              <div class="num-body"><span>X</span>{{ orderData.num }}</div>
            </div>
          </div>
          <div class="order-message">
            <div class="message-inner">
              <span>买家留言:</span>
              <el-input
                type="textarea"
                :rows="5"
                v-model="message"
                placeholder="选填填写内容与卖家确认"
              ></el-input>
            </div>
            <div class="order-price">
              <div class="price-total price-common">
                <div class="total-title title-common">商品总价 :</div>
                <div class="total-amount amount-common">
                  <span v-if="goodDetail.pays[0].payType === 1" style="font-size: 14px;margin-right: -4px;">¥</span>
                  {{ goodsTotalPrice }}
                  <span v-if="goodDetail.pays[0].payType !== 1">提货值</span>
                </div>
              </div>
              <div class="price-freight price-common" v-if="shippingFee > 0">
                <div class="freight-title title-common">运费 :</div>
                <div class="freight-amount amount-common">
                  <span style="font-size: 14px;margin-right: -4px;">¥</span>
                  {{ shippingFee.toFixed(2) }}
                </div>
              </div>
              <div class="price-pay price-common">
                <div class="pay-title title-common">支付金额 :</div>
                <div class="pay-amount amount-common" v-if="goodDetail.pays[0].payType === 1">
                  <span style="font-size: 14px;margin-right: -4px;">¥</span>
                  {{ paymentAmount.toFixed(2) }}
                </div>
                <div class="pay-amount amount-common" v-else>
                  {{ goodsTotalPrice }}提货值
                  <span v-if="shippingFee > 0" style="margin-right: -4px;">+ ¥ {{ shippingFee.toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 订单表单-底部 -->
        <div class="submit-footer">
          <div class="footer-btn" @click="deliveryByHold">提交订单</div>
        </div>
      </div>
    </div>
    <payDialog ref="payPop" @surePay="surePay" />
  </div>
</template>

<script>
/*global http protocol util */
import AddressList from '@/components/address/addressList.vue'
import payDialog from '@/components/base/payDialog/payDialog.vue'

export default {
  components: {
    AddressList,
    payDialog
  },
  data() {
    return {
      message: '', // 留言
      applyObj: {},
      buyNum: 1,
      myAccount: {
        balance: null
      },
      isPwdPay: true,
      chooseAddId: null,
      orderData: {},
      goodDetail: {},
      currentPrice: {},
      addressObj: {},
      shippingFee: 0,
      isRepeat: false,
      orderCode: null,
      allBanlce: 0, // 总余额
      allDeliveyVal: 0 // 总提货值
    }
  },
  computed: {
    totalPrice() {
      if (this.buyNum) {
        return util.floatMul(this.buyNum, this.applyObj.price)
      }
      return 0
    },
    // 计算商品总价（数量 × 单价）
    goodsTotalPrice() {
      if (!this.orderData || !this.orderData.num || !this.orderData.currentPrice) {
        return '0.00'
      }
      const num = this.orderData.num
      const price = this.orderData.currentPrice.discountPrice
      // 将数字转换为整数进行计算
      const numStr = String(num)
      const priceStr = String(price)
      // 获取小数位数
      const numDecimals = numStr.includes('.') ? numStr.split('.')[1].length : 0
      const priceDecimals = priceStr.includes('.') ? priceStr.split('.')[1].length : 0
      const maxDecimals = Math.max(numDecimals, priceDecimals)
      // 转换为整数计算
      const multiplier = Math.pow(10, maxDecimals)
      const numInt = Math.round(num * multiplier)
      const priceInt = Math.round(price * multiplier)
      const result = (numInt * priceInt) / (multiplier * multiplier)
      // 截取到两位小数
      return this.truncateToTwoDecimals(result)
    },
    // 计算支付金额（商品总价 + 运费）
    paymentAmount() {
      const goodsTotal = parseFloat(this.goodsTotalPrice)
      const shipping = parseFloat(this.shippingFee) || 0
      const goodsTotalCents = Math.round(goodsTotal * 100)
      const shippingCents = Math.round(shipping * 100)
      const totalCents = goodsTotalCents + shippingCents
      const result = totalCents / 100
      return this.truncateToTwoDecimals(result)
    }
  },
  mounted() {
    this.findMyAsset()
    this.getAssetT()
    this.orderData = this.$store.getters.goodDetailOrderDataGetter
    // 店铺详情
    this.goodDetail = this.orderData.goodDetail
    // 规格详情
    this.currentPrice = this.orderData.currentPrice
    console.log('详情', this.currentPrice)
    // 地址
    this.addressObj = this.orderData.addressObj
    // 设置选中的地址ID，用于在地址列表中高亮显示
    if (this.orderData.addressObj && this.orderData.addressObj.addressId) {
      this.chooseAddId = this.addressObj.addressId
    }
    this.calculateFreight(this.addressObj.addressId)
    this.generateOrderCode()
  },
  methods: {
    getBgColor(val) {
      switch (val) {
        case 'S':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FEECEB 100%)'
        case 'U':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FDF4DA 100%)'
        default:
          return '#fff'
      }
    },
    // 截取到两位小数（不四舍五入）
    truncateToTwoDecimals(num) {
      const numStr = String(num)
      if (!numStr.includes('.')) {
        return numStr + '.00'
      }
      // 分割整数和小数部分
      const parts = numStr.split('.')
      const integerPart = parts[0]
      const decimalPart = parts[1]
      const truncatedDecimal = decimalPart.substring(0, 2)
      // 如果小数位不足两位，补0
      const paddedDecimal = truncatedDecimal.padEnd(2, '0')
      return `${integerPart}.${paddedDecimal}`
    },
    // 计算运费
    calculateFreight(id) {
      protocol.param_calculateFreight.param.commoditySkuId = this.currentPrice.skuId
      protocol.param_calculateFreight.param.commodityId = this.goodDetail.commodityId
      protocol.param_calculateFreight.param.quantity = this.orderData.num
      protocol.param_calculateFreight.param.addressId = id
      http.postFrontMall(protocol.param_calculateFreight).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.shippingFee = value.shippingFee
          }
          return true
        } else {
          this.$message(message)
          return false
        }
      })
    },
    // 生成订单编码
    generateOrderCode() {
      http.postFrontMall(protocol.param_createOrderCode).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.orderCode = value
          }
        } else {
          this.$message(message)
          return false
        }
      })
    },
    deliveryByHold() {
      if (Number(this.allBanlce) < Number(this.paymentAmount)) {
        if (this.goodDetail.pays[0].payType === 2) {
          return this.$toast('可用提货值不足！')
        }
        return this.$toast('可用资金不足！')
      }
      this.makeOrder()
      // if (this.isPwdPay) {
      //   // 为真则出资金密码弹框
      //   const { typeName, price } = this.getPaymentDisplayInfo()
      //   this.$refs.payPop.showSheet(price, typeName)
      // } else {
      //   this.payOrder()
      // }
    },
    makeOrder() {
      const params = {
        addressId: this.addressObj.addressId,
        commodityId: this.goodDetail.commodityId,
        payType: this.goodDetail.pays[0].payType,
        quantity: this.orderData.num,
        bankId: this.isPwdPay ? window.g.BANK_ID : null,
        message: this.message,
        commoditySkuId: this.currentPrice.skuId,
        activityId: this.goodDetail.activityId || null,
        orderCode: this.orderCode
      }
      protocol.param_makeOrderSeckill.param = params
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      http.postFrontMall(protocol.param_makeOrderSeckill).then((response) => {
        const { code, message, value } = response.data
        this.isRepeat = false
        if (Number(code) === 0) {
          if (this.isPwdPay) {
            // 为真则出资金密码弹框
            // sessionStorage.setItem('buyNum', this.buyNum)
            // eslint-disable-next-line eqeqeq
            const { typeName, price } = this.getPaymentDisplayInfo()
            this.$refs.payPop.showSheet(price, typeName, value)
          } else {
            this.payOrder()
          }
        } else {
          this.$toast(message)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    // 获取支付弹窗显示信息
    getPaymentDisplayInfo() {
      const payType = this.goodDetail.pays[0].payType
      const symbolName = this.goodDetail.pays[0].symbolNameCh
      const hasShippingFee = this.shippingFee > 0
      const formattedShippingFee = this.shippingFee.toFixed(2)
      const formattedTotalAmount = payType === 2 ? this.goodsTotalPrice : this.paymentAmount

      // 提货值支付（payType === 2）
      if (payType === 2) {
        const typeName = '支付金额'
        // const typeName = `支付${symbolName}${hasShippingFee ? '+运费' : ''}`
        const price = `${formattedTotalAmount}${symbolName}${hasShippingFee ? ` +￥${formattedShippingFee}` : ''}`
        return { typeName, price }
      }

      // 余额支付（payType === 1）
      return {
        typeName: '支付金额',
        price: `￥${formattedTotalAmount}`
      }
    },
    // 选择地址
    changeAddId(id) {
      this.addressObj.addressId = id
      this.calculateFreight(id)
    },
    // 确定支付
    surePay(val) {
      this.payOrder(val)
    },
    // 支付订单
    payOrder(pwd) {
      const params = {
        addressId: this.addressObj.addressId,
        commodityId: this.goodDetail.commodityId,
        payType: this.goodDetail.pays[0].payType,
        quantity: this.orderData.num,
        password: this.isPwdPay ? util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd) : null,
        bankId: this.isPwdPay ? window.g.BANK_ID : null,
        message: this.message,
        commoditySkuId: this.currentPrice.skuId,
        orderCode: this.orderCode,
        activityId: this.goodDetail.activityId || null
      }
      protocol.param_payOrderSeckill.param = params
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      http.postFrontMall(protocol.param_payOrderSeckill).then((response) => {
        const { code, message, value } = response.data
        this.isRepeat = false
        if (Number(code) === 0) {
          this.resultPrice = value.totalPrice
          this.$refs.payPop.closeSheet()
          this.$message('支付成功！')
          setTimeout(() => {
            this.$router.replace(`/orderManagement/12`)
          }, 1000)
        } else {
          this.$refs.payPop.currentStatus = false
          this.$message(message)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    // 返回上一页
    handleGoBack() {
      // 返回时不清除 Vuex 中的状态数据
      // timeLimitDetail 页面的 activated 钩子会自动恢复状态
      console.log('返回商品详情页，保持用户选择的状态')
      this.$router.go(-1)
    },
    findMyAsset() {
      http.postFront(protocol.param_findMyAssetMarket).then(response => {
        const { code, message, value } = response.data
        if (code === '0') {
          if (value) {
            this.allBanlce = value?.availableFunds
          }
        } else {
          this.$message(message)
        }
      })
    },
    getAssetT() {
      protocol.param_findMyRewardMarket.param.rewardId = 472
      http.getRes(protocol.param_findMyRewardMarket).then((response) => {
        const { code, message, value } = response.data
        if (code === '0') {
          this.allDeliveyVal = value?.balance
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .sure-order-container {
    min-height: calc(100vh - 40px);
    background: #f4f4f4;
    position: relative;
    width: 100%;
    color: #333333;
    font-family: PingFang TC-Medium;
    // 回退
    .goBackIcon {
      cursor: pointer;
      height: 40px;
      width: 40px;
      position: absolute;
      top: 30px;
      left: 50px;
      background: #666666;
      color: #ffffff;
      font-size: 30px;
      line-height: 38px;
      text-align: center;
      border-radius: 2px;
    }
    // 主体
    .sure-order {
      // 标题
      .sure-order-title {
        width: 1200px;
        margin: 0 auto;
        height: 55px;
        line-height: 55px;
        font-size: 16px;
        font-weight: 500;
        text-align: left;
      }
      // 订单表单
      .sure-order-submit {
        width: 1200px;
        height: 420px;
        margin: 20px auto;
        font-size: 14px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // 订单表单-顶部
        .submit-header {
          width: 100%;
          height: 40px;
          padding: 0 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .header-title {
            font-weight: 500;
          }
          .header-money {
            display: flex;
            align-items: center;
            gap: 20px;
            .money-pick {
              span {
                &:nth-child(2) {
                  margin-left: 10px;
                }
              }
            }
            .money-amount {
              span {
                &:nth-child(2) {
                  margin-left: 10px;
                }
              }
            }
          }
        }
        // 订单表单-信息
        .submit-body {
          flex: 1;
          border-bottom: 1px solid #eeeeee;
          width: 100%;
          box-sizing: border-box;
          padding: 10px 0 0 10px;
          display: flex;
          flex-direction: column;
          .good-des {
            display: flex;
            align-items: flex-start;
            .title-common {
              font-size: 14px;
              color: #666666;
              font-weight: 400;
            }
            .des-common {
              &:nth-child(n+2) {
                width: 125px;
                height: 104px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              }
            }
            .des-info {
              .info-title {}
              .info-body {
                margin-top: 19px;
                .store-info {
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  img {
                    height: 16px;
                  }
                  span {
                    font-size: 16px;
                  }
                }
                .good-info {
                  margin-top: 11px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  img {
                    width: 36px;
                    height: 36px;
                  }
                  .info-text {
                    font-size: 12px;
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    .text-des {
                      color: #333333;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 300px;
                    }
                    .text-sku {
                      color: #999999;
                    }
                  }
                }
              }
            }
            .des-num {
              margin-left: auto;
              .num-body {
                span {
                  font-size: 12px;
                }
              }
            }
            .des-freight {
              .freight-body {
                span {
                  font-size: 10px;
                }
              }
            }
            .des-price {
              margin-right: 60px;
            }
          }
          .order-message {
            flex: 1;
            display: flex;
            .message-inner {
              margin-top: 10px;
              width: 50%;
              display: flex;
              align-items: flex-start;
              span {
                white-space: nowrap;
                font-size: 14px;
                color: #333333;
                margin-top: 2px;
              }
              /deep/.el-textarea {
                font-size: 14px;
                color: #333333;
                height: 20px;
                width: 40%;
                .el-textarea__inner {
                  border: none;
                  border-radius: 0;
                  padding-top: 1px;
                  padding-bottom: 0;
                  min-height: 20px !important;
                  resize: none;
                  &::-webkit-scrollbar {
                    width: 0 !important;
                    height: 0 !important;
                  }
                  &::placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                  &::-webkit-input-placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                  &::-moz-placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                }
              }
            }
            .order-price {
              display: flex;
              flex-direction: column;
              align-items: end;
              justify-content: end;
              flex: 1;
              padding-right: 50px;
              .price-common {
                display: flex;
                gap: 27px;
                .title-common {
                  width: 70px;
                  text-align: right;
                  color: #333333;
                  font-size: 14px;
                }
                .amount-common {
                  width: 200px;
                  text-align: right;
                }
              }
              .total-title {

              }
              .price-freight {
                margin-top: 10px;
              }
              .price-pay {
                margin-top: 20px;
                display: flex;
                align-items: center;
                .pay-amount {
                  font-size: 18px;
                  font-weight: 500;
                  color: #EB6643;
                  min-width: 200px;
                }
              }
            }
          }
        }
        // 订单表单-底部
        .submit-footer {
          height: 102px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .footer-btn {
            background: linear-gradient(to right, #EA553C, #EE8C54);
            width: 233px;
            height: 54px;
            margin-right: 30px;
            border-radius: 54px;
            line-height: 54px;
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            font-weight: 400;
            cursor: pointer;
            user-select: none;
            &:hover {
              filter: brightness(1.05)
            }
            &:active {
              filter: brightness(0.95)
            }
          }
        }
      }
    }
  }
</style>
